var render = function render(){var _vm=this,_c=_vm._self._c;return _c('checkbox-icon',{staticClass:"icon",class:{active: !!_vm.calculatedValue},on:{"click":_vm.toggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }